import { render, staticRenderFns } from "./MemberFloatingChatComponent.vue?vue&type=template&id=06979082&scoped=true&"
import script from "./MemberFloatingChatComponent.vue?vue&type=script&lang=js&"
export * from "./MemberFloatingChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberFloatingChatComponent.vue?vue&type=style&index=0&id=06979082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06979082",
  null
  
)

export default component.exports